import React from 'react';
import { Link } from 'react-router-dom';
// import ReactGA from 'react-ga';
import { GAinit, GAlogEvent } from '../components/common/GoogleAnalytics';
import isEmail from 'validator/lib/isEmail';
import axios from 'axios';
import getAppConfigParm  from '../config/AppConfig';
import { upperCaseFirst } from '../utils/strUtils';

// Goal is to keep track of local state for all of the inputs. Only when form is sumbitted and validated,
// do we want to submit change to redux store. That submission is handled by parent component.
// The form here is simply responsible for presenting the form, validating inputs, saving data in 
// local state, and passing data to onSumbit function prop for dispatch. As you may notice, there is
// is no connect() function imported for this component, therefore it cannot connect to redux.
export default class SignUpForm extends React.Component {

    constructor(props) {
        super(props);
    
        // local component state
        this.state = {
            firstname:          props.signup ? props.signup.firstname : '',
            lastname:           props.signup ? props.signup.lastname : '',
            email:              props.signup ? props.signup.email : '',
            password:           props.signup ? props.signup.password : '',
            passwordConfirm:    props.signup ? props.signup.passwordConfirm : '',
         //    amount:   props.expense ? (props.expense.amount / 100).toString() : '',
        //     createdAt:  props.expense ? moment(props.expense.createdAt) : moment(),
        //     calendarFocused: false,
            error: ''
        };
    }

    componentDidMount = () => {
        let env = getAppConfigParm("env");
        // if (env === 'dev' || env === 'test' || env === 'prod' ) {
        if (env === 'prod') {
            GAinit();
        }
    }

    // Be aware that "e.target.value" cannot be used in the callback inside this.setState()
    // This is why we assign e.target.value to variable first. You may use e.persist() 
    // instead of the assignment line before setState() instead.
    onFirstnameChange = (e) => {
        const firstname = e.target.value.trim();    
        this.setState(() => ({ firstname }));
    };

    onLastnameChange = (e) => {
        const lastname = e.target.value.trim();    
        this.setState(() => ({ lastname }));
    };

    onEmailChange = (e) => {
        const email = e.target.value.trim();     // assign input value to email; allows to use object shorthand on next line
        this.setState(() => ({ email })); // update email on local state using ES6 shorthand
    };

    onPasswordChange = (e) => {
        const password = e.target.value.trim();     // assign input value to description; allows to use object shorthand on next line
        this.setState(() => ({ password })); // update description on local state using ES6 shorthand
    };

    onConfirmPasswordChange = (e) => {
        const passwordConfirm = e.target.value.trim();    
        this.setState(() => ({ passwordConfirm }));
    };

    // Note: this local onSubmit method does validation, creates new user account, but 
    // does not dispatch the signUp action (which is responsible for saving auth token). 
    // The dispatch is done by the onSubmit method passed in as a function prop, from the 
    // SignUpPage. The function prop (this.props.onSubmit) is invoked with data needed 
    // for the SignUpPage to decide if and when an action is dispatched from the parent 
    // component (SignUpPage), and decide which page to route user based on outcome of
    // createNewUserAccount().  
    // This is a point of interest: because this component was not connected to redux
    // and was using local state to save form data before submitting it, I decided to 
    // place the axios api call within the onsubmit button below instead of an async action.
    // My concern was twofold. 1) did not want to mix usage of both local state and global state
    // in one component, and 2)  because axios is an async function and dispatch is an async
    // function, if I encountered a create new user account error, it was not clear if error would 
    // show immediately as the validation errro on form using local state. This is something
    // I may want to try with another form. If it does not work, I use this approach.
    onSubmit = (e) => {
        let self = this;
        e.preventDefault();
        if (this.isValidForm()) {   /* If valid form, create new user account */
            /* Try creating new user account. If no error, call onSubmit function prop, passing data to parent.  
               If there is an error, render error message to screen */
            this.createNewUserAccount().then(({id, firstname, lastname, email, token, errmsg}) => {
                if (!errmsg) { /* no error encountered creating new user account */
                    firstname = firstname;  /* convert 1st letter to uppercase */
                    lastname  = lastname;   /* convert 1st letter to uppercase */
                    this.props.onSubmit({
                        user: {
                            id, 
                            firstname,
                            lastname,
                            email
                        },
                        token 
                    });
                    /* Have google analytics log user signup event; log it only in prod environment */
                    let env = getAppConfigParm("env");
                    // if (env === 'dev' || env === 'test' || env === 'prod' ) {
                    if (env === 'prod') {
                        GAlogEvent('User', 'SignUp');
                    }
                } else {  /* encountered error creating new user account */
                    if (errmsg.indexOf('DuplicateRecord' !== -1))  {
                        errmsg = "User account already exist";
                    };
                    /* update error msg on local state so it displays to user when component re-renders*/
                    this.setState(() => ({error: errmsg})); 
                }
            }).catch((errmsg) => {  /* catch if error with axios call to create new user account*/
                console.log(errmsg);  /* print actual error message froma axios to console for you to view */
                errmsg = "Server issue. Please try again later."; /* create user friendly message */
                self.setState(() => ({error: errmsg})); /* set error message to show to user when component re-renders */
                // this.props.onSubmit({
                //     error
                // })
            })
        }
    };
    
    render() {
        return (
            <form className="form-signup" onSubmit={this.onSubmit}>
            {this.state.error && <p className="error">{this.state.error}</p>}
                <input 
                    type="text"
                    placeholder="First Name"
                    autoFocus
                    className="form__field"
                    value={this.state.firstname}
                    onChange={this.onFirstnameChange}
                />
                <input 
                    type="text"
                    placeholder="Last Name"
                    className="form__field"
                    value={this.state.lastname}
                    onChange={this.onLastnameChange}
                />
                <input 
                    type="text"
                    placeholder="Email address"
                    className="form__field"
                    onChange={this.onEmailChange}    // change the state.email value vi on change method
                    value={this.state.email}         // render component with value from state object
                />
                <input 
                    type="password"
                    placeholder="Password (minimum 8 chars)"
                    className="form__field"
                    value={this.state.password}
                    onChange={this.onPasswordChange}
                />
                <input 
                    type="password"
                    placeholder="Confirm Password"
                    className="form__field"
                    value={this.state.confirmPassword}
                    onChange={this.onConfirmPasswordChange}
                />
                <div>
                  <button className="signup-button">Create Account</button> 
                </div>
                { this.renderConditionalForgotPassword() }
            </form>
        )
    }

    renderConditionalForgotPassword = () =>  {
        if ( this.state.error.indexOf('already exist') !== -1 ) {
            return (
                <Link to="/forgotpw" className="small-text-link">Forgot Password?</Link> 
            )
        }
    };

    isValidForm = () => {
        let valid = false;
        if (!this.state.firstname || !this.state.lastname) {
            this.setState(() => ({ error: 'Please provide First Name, Last Name'}))
        } else
        if (!this.state.email || !isEmail(this.state.email)) {
            this.setState(() => ({ error: 'Please provide valid email address'}))
        } else
        if (!this.state.password) {
            this.setState(() => ({ error: 'Please provide password'}))
        } else
        if (this.state.password.length < 8) {
            this.setState(() => ({ error: 'Password minimum of 8 characters'}))
        } else
        if (!this.state.passwordConfirm ) {
            this.setState(() => ({ error: 'Please provide password confirmation'}))
        } else
        if (this.state.password !== this.state.passwordConfirm) {
            this.setState(() => ({ error: 'Passwords did not match, please update'}))
        } else {   // Clear the error when all validations passed
            this.setState(() => ({ error: ''}));
            valid = true;
        }
        return valid;
    }
   
    createNewUserAccount = () => {
        let self = this;
        let createUserPromise  = new Promise (

            function resolver(resolve, reject) {

                let signUpUrl   = getAppConfigParm("authUrl") + '/signup'; 
                let axiosConfig = getAppConfigParm("axiosConfig"); 
                let postData = {
                    firstname: upperCaseFirst(self.state.firstname),
                    lastname: upperCaseFirst(self.state.lastname),
                    email: self.state.email,
                    password: self.state.password
                };
                axios.post(signUpUrl, postData, axiosConfig)
                    .then(function (response) {
                        let errmsg = response.data.errmsg || '';
                        let firstname = response.data.firstname;
                        let lastname = response.data.lastname;
                        let email = response.data.email;
                        let id = response.data._id;
                        let token = response.headers["x-auth"];
                        resolve({id, firstname, lastname, email, token, errmsg});
                    }).catch (function (error){
                        let caughtError = error.message || error.name || "Axios Error";
                        let errorComponent = '"SignUpForm"';
                        let userEmail = postData.email;
                        // Concat parts of the error message below
                        var errorMsg = `${caughtError} occurred; component:'${errorComponent}'  Email:${postData.email}`
                        reject({error: errorMsg});
                });
            } // End of function resolver
        ); // End of promise
        return createUserPromise;
    }; // end of createNewUserAccount function

} // END OF REACT component



// WEBPACK FOOTER //
// ./src/components/SignUpForm.js